var styleDataHash = "0727b0a4";
const injectCss = () => {
  var css = `.J13B0{box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;height:fit-content;min-width:var(--ricos-internal-dropdown-modal-min-width,160px);overflow:hidden;padding-block:12px;width:fit-content;z-index:10}[dir] .J13B0{background-color:#fff;border-radius:var(--ricos-settings-whitebox-border-radius,8px);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 6px 6px 0 rgba(22,45,61,.06),0 0 18px 0 rgba(22,45,61,.12))}.J13B0 *,.J13B0 :after,.J13B0 :before{box-sizing:inherit}.J13B0 input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.J13B0{width:100%}}}@container (width < 640px){.J13B0{width:100%}}.vieuR{width:100%}.QRHsQ{--wds-side-panel-content-padding-vertical:12px;--wds-side-panel-content-padding-horizontal:0px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var dropdown_modal_default = {
  "root": "J13B0",
  "mobile": "vieuR",
  "mobileContent": "QRHsQ"
};
export {
  dropdown_modal_default as default,
  injectCss
};
//# sourceMappingURL=dropdown-modal-scss.js.map
